import { forwardRef } from "react";
import { cn } from "@/lib/utils";

const Input = forwardRef(({ className, ...props }, ref) => {
  return (
    <input
      ref={ref}
      className={cn(
        "w-full px-4 py-3.5 rounded-2xl border-[1.5px] border-gray-200 text-[15px] font-bold text-app-text bg-white outline-none transition-all duration-200",
        "focus:border-pawcare-orange focus:ring-[3px] focus:ring-pawcare-orange/15",
        "placeholder:text-gray-300 placeholder:font-semibold",
        className
      )}
      {...props}
    />
  );
});

Input.displayName = "Input";
export { Input };
